import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "view-table",
  "use": "view-table-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"view-table\">\n  <path fill=\"#677078\" d=\"M10,18 L15,18 L15,5 L10,5 L10,18 Z M4,18 L9,18 L9,5 L4,5 L4,18 Z M16,5 L16,18 L21,18 L21,5 L16,5 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol